 
import React, { useCallback } from 'react';

import { EVENT_ACTION } from '../../../constants/analytics.constants';
import * as Analytics from '../../analytics';

interface Props {
  eventAction?: string;
  onClick?: any;
  [key: string]: any;
}

const withTaggingFieldAccordionClickHandler = (WrappedComponent: any) =>
  function TaggingFieldAccordionClick({
    eventAction,
    onClick,
    ...rest
  }: Props) {
    const handleOnClick = useCallback(
      (...args) => {
        if (onClick) {
          onClick(...args);
        }
        if (eventAction) {
          Analytics.sendAccordionEvent(
            EVENT_ACTION.SUPPORTING_MATERIAL,
            eventAction,
          );
        }
      },
      [onClick, eventAction],
    );
    return <WrappedComponent {...rest} onClick={handleOnClick} />;
  };

export default withTaggingFieldAccordionClickHandler;
